export const setDataToLS = <T>(key: string, value: T) => {
  localStorage.setItem(key, JSON.stringify(value))
}

export const getDataFromLS = <T>(key: string): T => JSON.parse(localStorage.getItem(key)!)
